import BaseRequest from './BaseRequest';

const schema = 'transaction';
/**
 * key base on host:port
 */
export default class TransactionRequest extends BaseRequest {
  /**
	 * @param {Object} params
	 * @param {string} params.password
	 * @param {string} params.email
	 * @param {string} params.country
	 * @param {string} params.home_address
	 * @param {string} params.postal_code
	 * @returns {Promise<BaseRequest._responseHandler.props.data|undefined>}
	 */
  withdrawal(params) {
    const url = `${schema}/withdrawal`;
    return this.post(url, params);
  }

  /**
	 * @param {Object} params
	 * @param {string} params.password
	 * @param {string} params.email
	 * @param {string} params.country
	 * @param {string} params.home_address
	 * @param {string} params.postal_code
	 * @returns {Promise<BaseRequest._responseHandler.props.data|undefined>}
	 */
  withdrawalCustom(params) {
    const url = `${schema}/withdrawal-custom`;
    return this.post(url, params);
  }

  /**
	 * @param {Object} params
	 * @param {string} params.pos
	 * @param {string} params.count
	 * @param {number} params.trans_type
	 * @returns {Promise<BaseRequest._responseHandler.props.data|undefined>}
	 */
  fetchWithdrawalHistory(params) {
    const url = `${schema}/history`;
    return this.get(url, params);
  }

  /**
	 * @param {Object} params
	 * @param {string} params.token
	 * @returns {Promise<BaseRequest._responseHandler.props.data|undefined>}
	 */
  verifyWithdrawal(params) {
    const url = `${schema}/verify-withdraw`;
    return this.get(url, params);
  }

  /**
	 * @param {Object} params
	 * @param {string} params.currency
	 * @returns {Promise<BaseRequest._responseHandler.props.data|undefined>}
	 */
  fetchUserVolume24h(params) {
    const url = `${schema}/user-volume-24h`;
    return this.get(url, params);
  }

  filterTransaction(params) {
	  const url = `${schema}`;
	  return this.post(url, params);
  }
}
